import * as requests from "../coraWebComponents/utils/requests";
import Urls from "../constants/Urls";

export const login = async (username, password) => {
  try {
    let res = await requests.signIn(username, password);
    return res;
  } catch (error) {
    throw error;
  }
};

export const refreshUser = async () => {
  try {
    let res = await requests.refreshToken();
    return res;
  } catch (error) {
    throw error;
  }
};

export const forgotPassword = async (email) => {
  try {
    let res = await requests.post(Urls.ForgotPassword, email);
    return res;
  } catch (error) {
    throw error;
  }
};

export const changePassword = async (data) => {
  try {
    let res = await requests.post(Urls.ChangePassword, data);
    return res;
  } catch (error) {
    throw error;
  }
};

export const refreshToken = () => requests.refreshToken();
